import { VALIDATE_CHARACTER } from "common/Constants";
import moment from "moment";

export const EligibleList = ["Both", "Male", "Female"];
const DoYouWant = ["Yes", "No"];
const AllocationOption = ["Monthly"];
const fixedYear = moment().add(1, "year").year();

export const getAddLeaveJson = (data, LeaveList) => {
  console.log("data1212-->", data);
  const AddLeaveForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          // Row 1
          [
            {
              id: 1,
              label: "Leave Name",
              type: "text",
              name: "leave_category_name",
              Placeholder: "Leave Name",
              value: data["leave_category_name"],
              maxLength: 100,
              validationRules: [
                {
                  required: true,
                  message: `Please enter your Leave Name`,
                },
                {
                  validator: (rule, value, callback) => {
                    if (value) {
                      const isValidChar =
                        VALIDATE_CHARACTER &&
                        typeof VALIDATE_CHARACTER.test === "function"
                          ? VALIDATE_CHARACTER.test(value)
                          : true;
                      if (!isValidChar) {
                        callback(
                          "Leave Name should not contain special characters"
                        );
                        return;
                      }
                    }
                    callback();
                  },
                },
                {
                  validator: (rule, value) => {
                    if (
                      LeaveList.some((data) => data.leaveCategoryName === value)
                    ) {
                      return Promise.reject("Leave already exists");
                    }

                    return Promise.resolve();
                  },
                },
              ],
              onKeyDown: (e) => {
                const key = e.key;
                const currentValue = e.target.value || "";
                const allowedKeys = [
                  "Backspace",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                  "Delete",
                  "Home",
                  "End",
                  " ",
                ];
                const isAlphaNumeric = /^[a-zA-Z]$/.test(key);
                if (currentValue.length >= 50 && !allowedKeys.includes(key)) {
                  e.preventDefault();
                }
                if (!isAlphaNumeric && !allowedKeys.includes(key)) {
                  e.preventDefault();
                }
              },
            },
          ],
          [
            {
              id: 2,
              label: "Number of Days",
              type: "text",
              name: "number_of_leaves",
              Placeholder: "Number of Leaves",
              value: data["number_of_leaves"],
              maxLength: 4,
              validationRules: [
                {
                  required: true,
                  message: "",
                },
                {
                  validator: (_, value) => {
                    if (value === undefined || value === null || value === "") {
                      return Promise.reject("Please enter your Number of Days");
                    }
                    if (Number(value) === 0) {
                      return Promise.reject(
                        "Please enter your Number of Days greater than zero"
                      );
                    }
                    if (Number(value) >= 200) {
                      return Promise.reject(
                        "Please enter your Number of Days less than 200"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ],
              onKeyDown: /^[0-9 .]$/,
            },
          ],
          [
            {
              id: 3,
              label: "Eligible",
              type: "radio",
              name: "eligible",
              Placeholder: "Select",
              value: "",
              options: EligibleList,
              validationRules: [
                {
                  required: true,
                  message: `Please select the eligible`,
                },
              ],
            },
          ],
          [
            {
              id: 4,
              label: "Do you want to include Saturdays in this leave?",
              type: "radio",
              name: "isSaturday",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: `Please select`,
                },
              ],
            },
          ],
          [
            {
              id: 4,
              label: "Do you want to include Sundays in this leave?",
              type: "radio",
              name: "weekend",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: `Please select`,
                },
              ],
            },
          ],
          [
            {
              id: 5,
              label: `Do you want to include the "Holidays" you provide in this leave?`,
              type: "radio",
              name: "holiday",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: `Please select`,
                },
              ],
            },
          ],
          [
            {
              id: 10,
              label: "Do you want to include Reliever?",
              type: "radio",
              name: "reliever",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: "Please select",
                },
              ],
            },
          ],
          [
            {
              id: 6,
              label: `Does this leave type use an accrual system?`,
              type: "radio",
              name: "accrual",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: `Please select`,
                },
              ],
            },
          ],
          ...(data["accrual"] === "Yes"
            ? [
                [
                  {
                    id: 7,
                    label: `Accrual Frequency`,
                    type: "radio",
                    name: "accrualtype",
                    Placeholder: "Select",
                    value: "",
                    options: AllocationOption,
                    validationRules: [
                      {
                        required: true,
                        message: `Please select`,
                      },
                    ],
                  },
                ],
              ]
            : []),

          ...(data["rollout"] === "Yes"
            ? [
                [
                  {
                    id: 9,
                    label: "Expiry Date",
                    type: "date",
                    name: "expiry_date",
                    Placeholder: "Select Expiry Date",
                    value: data["expiry_date"] || "",
                    picker: "month",
                    format: "MMMM",
                    defaultPickerValue: moment().add(1, "year"),
                    // validationRules: [
                    //   {
                    //     required: true,
                    //     message: `Please select expiry date`,
                    //   },
                    // ],
                    disabledDate: (current) => {
                      return current.year() !== fixedYear;
                    },
                  },
                ],
              ]
            : []),
          [
            {
              id: 2,
              label: "Next",
              type: "button",
              position: "end",
              // background: "Orange",steps
              textColor: "white",
              event: "submit",
            },
          ],
        ],
      },
    ],
  };

  return {
    AddLeaveForm,
  };
};
